export const breazeView = {
  canAccessNotificationSettings: false,
  canEarnAchievements: false,
  courseMode: false,
  courseSettings: {},
  notifications: false,
  theme: '',
  trackers: [{id:'UA-152962365-19', name:'default'}],
};
